module.exports = __webpack_public_path__ + "img/logo_bcr_0.7a9ad304.png";